module.exports = __webpack_public_path__ + "fonts/ebac-icons.4e217af.woff";